<template>  
  <div class="pagebaworder">
    <mu-appbar>
        <div class="title-text" @click="open('top')">
          <p>{{chainCname}}订单 <i :class="titleIcon"></i></p>    
           <mu-popup position="top" popupClass="pageorder-popup" :open="topPopup" @close="close('top')">
           <mu-content-block>
              <div class="popuptitle delivery-type-order">
                <div class="title">
                  <div class="text">所有订单</div>
                  <hr class="line">
                </div>
                <div class="button-list">   
                  <mu-flat-button v-on:click="$router.push('/usercenter/allorderlist')" label="全部订单"/>               
                  <mu-flat-button v-on:click="$router.push('/usercenter/orderList?typeValue=1&typeId=deliveryType')" label="物流订单" class="demo-flat-button"/>
                  <mu-flat-button v-on:click="$router.push('/usercenter/orderList?typeValue=2&typeId=deliveryType')" label="自提订单" class="demo-flat-button"/>
                  <mu-flat-button v-on:click="$router.push('/usercenter/orderList?typeValue=3&typeId=twoOrderType')" label="秒杀订单" class="demo-flat-button"/>
                  <mu-flat-button v-if="isIntegral" v-on:click="$router.push('/usercenter/integralOrderList')" :label="pointInfo.PointName + '订单'" style="text-transform:none" class="demo-flat-button"/>
                  <mu-flat-button v-on:click="$router.push('/usercenter/chainOrderList')" :label="chainCname + '订单'" class="demo-flat-button select"/>
                  <mu-flat-button v-if="!closeShangquan" class="demo-flat-button" v-on:click="$router.push('/shangquan/offlinePayList')" label="线下买单"/>
                </div>
              </div>              
            </mu-content-block>
          </mu-popup>     
        </div>
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <mu-icon-button to="/usercenter/chainOrdersearch" icon=":fa fa-xisearch" slot="right"/>
        <mu-icon-button v-on:click="RightButonClick()" icon=":fa fa-more" slot="right"/>
        <XR-drawer right :open="rightDrawer" :docked="docked" width="70%" @close="closeDrawer()">
          <div class="right-condition">
            <div class="condition-item">
              <div class="title">下单时间</div>
              <div class="condition-content create-time">
                <div :class="searchInfo.searchTimeType==0?'value select':'value'" @click="searchTimeSelect(0)">全部</div>
                <div :class="searchInfo.searchTimeType==1?'value select':'value'" @click="searchTimeSelect(1)">一个月内</div>
                <div :class="searchInfo.searchTimeType==2?'value select':'value'" @click="searchTimeSelect(2)">一个月至三个月</div>
                <div :class="searchInfo.searchTimeType==3?'value select':'value'" @click="searchTimeSelect(3)">三个月至六个月</div>
                <div :class="searchInfo.searchTimeType==4?'value select':'value'" @click="searchTimeSelect(4)">六个月至一年</div>
                <div :class="searchInfo.searchTimeType==5?'value select':'value'" @click="searchTimeSelect(5)">一年以上</div>
              </div>
            </div>
          </div>
          <div class="condition-button">
            <div class="cbutton condition-reset" @click="searchTimeSearch(0)">重置</div>
            <div class="cbutton condition-yes" @click="searchTimeSearch(searchInfo.searchTimeType)">确定</div>
          </div>
        </XR-drawer>
    </mu-appbar>
    <!-- <XR-head titleText="BAW订单" :rightShow="false" ref="headObj"></XR-head> -->
    <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">

      <div class="state-bar">
        <div :class="searchInfo.searchType==0?'state-item select':'state-item'" @click="searchTypeSearch(0)">全部</div>
        <div :class="searchInfo.searchType==1?'state-item select':'state-item'" @click="searchTypeSearch(1)">待支付</div>
        <div :class="searchInfo.searchType==2?'state-item select':'state-item'" @click="searchTypeSearch(2)">待发货</div>
        <div :class="searchInfo.searchType==3?'state-item select':'state-item'" @click="searchTypeSearch(3)">待收货</div>
        <div :class="searchInfo.searchType==4?'state-item select':'state-item'" @click="searchTypeSearch(4)">待评价</div>
        <div :class="searchInfo.searchType==5?'state-item select':'state-item'" @click="searchTypeSearch(5)">已完成</div>
      </div>
    
      <div class="order-list" v-if="!loaded">
        <div class="order-item" v-for="orderEntity in orderList" :key="orderEntity.OrderNo">
          <div class="shoptip">
            <img  class="shop-logo" :src="orderEntity.ShopLogo?orderEntity.ShopLogo:siteConfig.Icon" />
            <p class="shop-name">{{orderEntity.ShopName}}</p>
            <p class="state">{{orderEntity.StateName}}</p>
          </div>
          <div class="hidden-scorll">
            <router-link :to="'/usercenter/chainOrderDetail?orderNo='+orderEntity.OrderNo">
              <div class="suborder-item-list">
                <div :class="orderEntity.OrderItems.length>1?'suborder-item more':'suborder-item'">
                  <template v-for="orderItem in orderEntity.OrderItems">                    
                    <img :src="orderItem.DefaultImg?orderItem.DefaultImg:IMGServer_URL+'/images/index-item-default.png'" onerror="this.src=IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
                    <p v-if="orderEntity.OrderItems.length==1" class="product-name" :style="{width:suborderItemProductNameWidth+'px'}">
                      {{orderItem.ProductName + " "+ orderItem.Attribute}}
                    </p>
                  </template>
                </div>
              </div>
            </router-link>
          </div>
          <div class="order-total">
            <p class="total-text">共{{orderEntity.OrderItems.length}}件商品 实付款：<span><i class="fa fa-rmb"></i>{{orderEntity.Money.CashMoney.toFixed(2)}}</span>
            </p>
            <p class="total-text" style="clear:both;margin-top:-30px;">
			   <span style="text-align:right">
			   　{{chainCname}}支付：{{orderEntity.Money.TotalBaw.toFixed(chainDecimal)}}{{chainCname}}</span>
			   </span>
            </p>
          </div>
          <div class="order-operator">
            <div class="button-list">          
              <mu-raised-button label="取消订单" @click="orderCancel(orderEntity.OrderNo)" class="orderBtn receive" v-if="orderEntity.State ==1"></mu-raised-button>  
              <mu-raised-button label="确认收货" @click="orderConfrim(orderEntity.OrderNo)" class="orderBtn receive" v-if="orderEntity.State == 5 || orderEntity.State == 6"></mu-raised-button>
              <router-link :to="'/baw/orderPay?orderNo='+orderEntity.OrderNo" v-if="orderEntity.State == 1">
                <mu-raised-button label="付款" class="orderBtn gobuy"></mu-raised-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </v-scroll>
    <XR-toast ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
import config from '../../util/siteconfigCache'
import pointconfig from '../../util/pointconfigCache'
export default {
  name : 'XR-order-head',
  data () {
    return {
	  pointInfo: pointconfig.getPointconfig(),
      titleIcon : 'fa fa-angle-down',
      topPopup: false,
      rightDrawer: false,
      docked:false,
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-90),
      loaded:true,
      orderList:[],
      siteConfig: config.getSiteconfig(),
      pageEnd : 0, // 结束页数
      searchInfo:{
        searchType : this.$route.query.searchType ? parseInt(this.$route.query.searchType):0,
        searchTimeType:0,
        pageIndex : 0, // 开始页数
		deliveryType:0,
        twoOrderType:0,
        orderNo : this.$route.query.orderNo
      },
      scrollDone:function(){}
    }
  },
  mounted(){
    this.getPointInfo()
    this.getOrderList(true)
  },
  methods: {
    getPointInfo: function() {
      const ths = this;
      this.$post("/Shop/IntegralServer/GetPointSetParam")
      .then(function(res) {
        if (res.IsSuccess) {
		  ths.pointInfo = res.Data;
          pointconfig.addPointconfig(res.Data)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    RightButonClick: function(){
      this.topPopup = false
      this.rightDrawer = true
    },    
    open (position) {
      this[position + 'Popup'] = true
      this.titleIcon = "fa fa-angle-up";
    },
    close (position) {
      this[position + 'Popup'] = false
      this.titleIcon = "fa fa-angle-down";
    },
    closeDrawer () {
      this.rightDrawer = false
      this.titleIcon = "fa fa-angle-down";
    },
    GoHistory(){
      this.$router.goBack()
    },
    getOrderList(isNewSearch){  
      this.$refs.XRtoast.load() 

      if(isNewSearch){        
        this.searchInfo.pageIndex=1
      }
      else{        
        this.searchInfo.pageIndex++
      }

      var ths = this;   
      ths.$post(
        "/Shop/" + this.chainName + "Server/Get" + this.chainName + "OrderPage",
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.scrollDone()
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){          
          if(isNewSearch){
            ths.orderList = []
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{
           ths.$refs.XRtoast.failed(res.Msg, true)
          }  
        }else{    
          if(isNewSearch){
            ths.orderList =res.Data.List
          }
          else{            
            for(var i = 0; i < res.Data.List.length;i++){            
              ths.orderList.push(res.Data.List[i])
            }
          }
          ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num

          if(ths.orderList.length<=0){            
            ths.$refs.XRPageTip.ShowEmpty(res.Msg)
          }else{            
            ths.$refs.XRPageTip.initTip()
          }
          
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    searchTypeSearch(type){
      this.loaded =true
      this.searchInfo.searchType = type
      this.getOrderList(true)
    },
    searchTimeSelect(timeType){
      this.searchInfo.searchTimeType = timeType
    },
    searchTimeSearch(timeType){
      this.loaded =true
      this.searchInfo.searchTimeType = timeType
      this.closeDrawer()
      this.getOrderList(true)
    },    
    orderCancel(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/" + this.chainName + "Server/orderCancel",
        JSON.stringify({OrderNo: orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderList(true)
          })
        }
      });
    },
    orderConfrim(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/" + this.chainName + "Server/OrderConfrim",
        JSON.stringify({OrderNos: [orderNo]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderList(true)
          })
        }
      });
    },
    onRefresh(done) {
      //this.getOrderList();
      done() // call done      
    },
    onInfinite(done) {
      this.scrollDone = done
      if(this.searchInfo.pageIndex+1 > this.pageEnd){
        this.$refs.XRtoast.failed("已经到最后一页", true)
        return
      }
      this.getOrderList(false);     
    }
  }
}
</script>

<style>
.pagebaworder .mu-appbar-title{
  width: 70%;
}
.pagebaworder .xr-pageTip{
  top:104px;
}
.pagebaworder .child-view{
  background: #fff;
}
.pagebaworder .mu-appbar{
  position: relative;
  height: 46px;
  text-align: center;
  z-index: 20180101;
}
.pagebaworder .mu-appbar-title {
  font-size: 16px;
}
.pagebaworder .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.pagebaworder .title .title-text {
  margin: 0;
  padding:0;
  line-height: 48px;
}
.pagebaworder .mu-appbar .right{
  width: 25%;
}
.pagebaworder-popup {
  width: 100%;
  top:46px;
  height: 260px;
  z-index: 1;
  padding: 20px 0;
}
.pagebaworder-popup .popuptitle .title{
  overflow: hidden;
}
.pagebaworder-popup .popuptitle .title .text{
  float: left; 
  width:20%;
  text-align: center;
  line-height: 24px;
  color:#ccc;
}
.pagebaworder-popup .popuptitle .title .line{
  float: left; 
  height: 1px;
  background:#eee;
  width: 80%;
  border: none;
  margin-top: 10px;
}
.pagebaworder-popup .button-list{
  padding: 20px 0;
}
.pagebaworder-popup .button-list .demo-flat-button.select {
  color:red;
}
.pageorder-popup {
  width: 100%;
  top:46px;
  height: 260px;
  z-index: 1;
  padding: 20px 0;
}

.pagebaworder .state-bar{
  overflow: hidden;
  background: white;
}
.pagebaworder .state-bar .state-item{
  float: left;
  width: 16.66%;
  line-height: 48px;
  text-align: center;
  font-size: 12px;
}
.pagebaworder .state-bar .state-item.select{
  color:red;
}

.pagebaworder .right-condition{
  overflow: hidden;
}
.pagebaworder .right-condition .condition-item{
  overflow: hidden;
}
.pagebaworder .right-condition .condition-item .title{
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  padding: 20px 10px 0 20px;
}
.pagebaworder .right-condition .condition-item .condition-content{
  overflow: hidden;
  padding: 10px;
}
.pagebaworder .right-condition .condition-item  .condition-content .value{
  float: left;
  width: 45.9%;
  font-size: 12px;
  border: 1px solid #eee;
  margin: 2%;
  line-height: 24px;
  border-radius: 4px;
  background: #eee;
}
.pagebaworder .right-condition .condition-item  .condition-content .value.select{
  float: left;
  width: 45.9%;
  font-size: 12px;
  border: 1px solid red;
  margin: 2%;
  line-height: 24px;
  border-radius: 4px;
  background: white;
}
.pagebaworder .condition-button{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
}
.pagebaworder .condition-button .cbutton{
  float: left;
  width: 50%;
  border-top:1px solid #eee;
}
.pagebaworder .condition-button .condition-yes{
  background: red;
  border-top:1px solid #eee;
  color:white;
}


.pagebaworder .order-list{
  overflow: hidden;
}
.pagebaworder .order-item{
  background: white;
  margin: 10px 0;
}
.pagebaworder .shoptip{
  overflow: hidden;
  background: white;
  padding:0 10px;
}
.pagebaworder .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.pagebaworder .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.pagebaworder .shoptip .state{
  float: right;
  line-height: 48px;
  color:Red;
}

.pagebaworder .hidden-scorll{
  overflow: hidden;
}
.pagebaworder .suborder-item-list{
  background: #F8F8F8;
  overflow-x:scroll;
  overflow-y: hidden;

}
.pagebaworder .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 15px 0;
}
.pagebaworder .suborder-item.more{
  width:710px;
}
.pagebaworder .suborder-item .order-img{
  width: 60px;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
  margin-left: 10px;
}
.pagebaworder .suborder-item .product-name{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
  overflow: hidden;
  height: 60px;
  line-height: 20px;
  color:#333;
}

.pagebaworder .order-total{
  overflow: hidden;
  border-bottom:1px solid #eee;
  padding:0 10px;
}
.pagebaworder .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.pagebaworder .total-text span{
  font-size: 14px;
}

.pagebaworder .order-operator{
  overflow: hidden;
}

.pagebaworder .order-operator .button-list{
  float: right;
}
.pagebaworder .order-operator .button-list .orderBtn{
  margin: 10px 5px 10px 0;
}

.pagebaworder .order-opertaor .receive{
  
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/yscOrderList.vue